/**
 * Helper class to calculate fee for a unit in the context of a course and student type
 */
class FeeCalculator {
   /**
    * Number of credits for a full-time student.
    * Fees that are returned by the fees services will be annual fees based on this number of credits
    */
   static fullCreditLoad = 24

   /**
    *
    * @param {Object} course The course object that's returned by curriculum API
    * @param {Object} fees The fees object returned by the fees service.
    */
   constructor(course, fees) {
      this.course = course
      this.fees = fees
   }

   /**
    * Getter for course code
    */
   get courseCode() {
      return this.course ? this.course.code : ''
   }

   /**
    * Getter for course abbreviation
    */
   get courseAbbreviation() {
      return this.course ? this.course.abbreviation : ''
   }

   calculateTotal(units, log = false) {
      const seenItems = [];
      let totalFeeSum = units.reduce((sumOfFees, unit) => {
         if (seenItems.indexOf(unit.id) < 0)
         {
            sumOfFees += this.calculate(unit)
         }
         seenItems.push(unit.id)
         return sumOfFees
      }, 0);
      return totalFeeSum;
   }

   /**
    * Calculate fee for the given unit in the context of the fees and course object
    * @param {Object} unit the unit object returned by the curriculum API
    * @param {Boolean} log if true, log will be printed to console
    * @returns the fees for the unit or null if fee is not found.
    */
   calculate(unit, log = false) {
      var fee = 0;
      var found = false;
      var foundFee = {}

      if (log) console.log("Getting fees for -> " + unit.code)

      // checks for unit based fee first
      if (this.fees[2].units.length > 0 && !found) {
         foundFee = this.fees[2].units.filter(x => x.unitCode === unit.code)
         if (foundFee.length > 0) {
            fee = foundFee[0]
            found = true
            if (log) console.log("Unit Based Fees NOT Fee per EFTSL")
         }
      }

      // then checks for school based fee
      if (this.fees[3].schoolOverrides.length > 0 && this.courseAbbreviation && !found) {
         foundFee = this.fees[3].schoolOverrides.filter(x => {
            return this.courseAbbreviation.toLowerCase().includes(x.courseCode.toLowerCase()) && unit.code.startsWith(x.unitCode.replace(/\*/g, ''))
         })
         if (foundFee.length > 0) {
            fee = foundFee[0]
            found = true
            if (log) console.log("School Based Fees")
         }
      }

      // then checks for course based fee
      if (this.fees[1].courses.length > 0 && this.courseCode && !found) {
         foundFee = this.fees[1].courses.filter(x => x.courseCode === this.courseCode)
         // console.log(foundFee, unit.code)
         if (unit.code !== 'N/A' && foundFee.filter(x => x.unitCode === unit.code).length > 0) {
            foundFee = foundFee.filter(x => x.unitCode === unit.code)
            fee = foundFee[0]
            found = true
            if (log) console.log("Course Unit Based Fees", fee)
         } else if (foundFee.filter(x => x.unitCode === "N/A").length > 0) {
            foundFee = foundFee.filter(x => x.unitCode === "N/A")
            fee = foundFee[0]
            found = true
            if (log) console.log("Course Based Fees", fee)
         }
      }

      // then checks for field of education based fee
      if (this.fees[0].fieldsOfEducation && unit.fieldOfEducation && !found) {
         var foe = unit.fieldOfEducation.detailed.substring(0, 6)
         foundFee = this.fees[0].fieldsOfEducation.filter(x => foe === x.fieldOfEducation)
         fee = foundFee[0]
         if (log) console.log("FOE Based Fees", foe, fee)
      }

      // if fee is found, calculate the units fee based on its credits proportion to the full credit load
      if (foundFee[0]) {
         fee = Math.floor((foundFee[0].fee / FeeCalculator.fullCreditLoad) * unit.credits)
      } else {
         fee = null
      }
      if (log) console.log("=================================================")
      return fee
   }
}

module.exports = FeeCalculator
